export const SUPPORT_EMAIL = 'support@stratumn.com';
